import React from 'react';
import MarketHoursTable from './MarketHoursTable';

const MarketHoursLosers = ({ data }) => {
    return (
        <MarketHoursTable
            type="losers"
            titleTop="Biggest Losers:"
            title="Identify Top Declining Stocks of the Day"
            info="The 'Market Biggest Losers' screener provides a list of stocks that have experienced the largest percentage losses in value within a single trading day."
            data={data}
        />
    );
};

export default MarketHoursLosers;